<template>
  <el-tooltip :show-arrow="true">
    <template #content>
      <div v-if="officeHourDays && officeHourDays.length > 0">
        <div v-for="(day, index) in officeHourDays" :key="index">
          <strong>{{ day.name }}:</strong>&nbsp;
          <template v-if="day.isOpen">{{ day.openTime }} - {{ day.closeTime }}</template>
          <template v-else>Closed</template>
        </div>
      </div>
      <div v-else>
        You haven't set your office hours yet!
      </div>
    </template>
    <slot />
  </el-tooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { IOfficeHourDay } from '@/api/types/response.types'

export default defineComponent({
  name: 'MailboxSettingsOfficeHoursTooltip',

  props: {
    officeHourDays: {
      type: Array as () => IOfficeHourDay[],
      default: (): IOfficeHourDay[] => [],
    },
  },
})
</script>
